export enum TherapyFlagEnum {
	BOOKING = 'M',
	REBOOKING = 'R',
}
